// import ReactPlayer from "react-player";
import { EnvelopeCircleIcon } from "../components/icons/envelopeCircle";
import { FacebookIcon } from "../components/icons/facebook";
import { InstagramIcon } from "../components/icons/instagram";
import { LinkIcon } from "../components/icons/link";
import { PhoneCircleIcon } from "../components/icons/phoneCircle";
import logoLtcaTranspUrl from "@/assets/logo-ltca-academy.png";
// import ytCover from "../assets/yt_cover.webp";
// import { useMeasure } from "@uidotdev/usehooks";
import { version } from "../../package.json";
import { LinkedinIcon } from "@/components/icons/linkedin";
// import { useState } from "react";
// import { ErrorTest } from "@/components/ErrorTest";

export const Contact = (): JSX.Element => {
	// const [ref, { width }] = useMeasure();
	// const [isRefreshing, setIsRefreshing] = useState(false);
	// const isStaging =
	// 	import.meta.env.VITE_BUILD_ENV === "staging" ||
	// 	import.meta.env.VITE_BUILD_ENV === "development";

	// const handleForceRefresh = async () => {
	// 	if (isRefreshing) return;

	// 	setIsRefreshing(true);

	// 	try {
	// 		// Clear Service Worker caches
	// 		if ("caches" in window) {
	// 			const cacheNames = await caches.keys();
	// 			await Promise.all(cacheNames.map((name) => caches.delete(name)));
	// 			console.log("✅ Service Worker caches cleared");
	// 		}

	// 		// Clear browser storage
	// 		localStorage.clear();
	// 		sessionStorage.clear();
	// 		console.log("✅ Browser storage cleared");

	// 		// Wait a moment for caches to clear
	// 		await new Promise((resolve) => setTimeout(resolve, 300));

	// 		// Hard reload with cache bypass
	// 		window.location.href =
	// 			window.location.href.split("?")[0] + "?nocache=" + Date.now();
	// 	} catch (error) {
	// 		console.error("❌ Failed to force refresh:", error);
	// 		setIsRefreshing(false);
	// 		alert("Błąd podczas odświeżania. Spróbuj ponownie.");
	// 	}
	// };

	return (
		<main className="py-3 px-safe-offset-3 min-h-[calc(100vh-176px)] overflow-x-hidden max-w-[890px] mx-auto">
			{/* <div ref={ref} className="m-5"> */}
			<div className="m-5">
				<div className="border-b-[1px] border-dashed border-slate-300 my-4">
					<div className="flex justify-between items-center mb-3">
						<h2 className="text-sm text-slate-400 font-medium">O NAS</h2>
						<img
							alt="LCTA Logo"
							className="h-12 lg:hidden"
							src={logoLtcaTranspUrl}
						/>
					</div>
					<h1 className="font-bold mb-3">
						Akademia LTCA - miejsce dla tych, którzy chcą wiedzieć więcej.
					</h1>
					<p className="font-light mb-3 text-justify">
						To jedna z największych w Polsce platform szkoleniowych z zakresu
						podatków, prawa, prawa pracy, finansów, kompetencji miękkich, AI i
						cyberbezpieczeństwa.
					</p>
					{/* <ReactPlayer
						playing
						playsinline
						height={width ? width * 0.6 : 60}
						light={ytCover}
						style={{ marginBottom: "20px" }}
						url="https://www.youtube.com/embed/-w8AHjDvHRw?si=0o9cKKpaNaJsERqd"
						width={width || 100}
					/> */}
				</div>
				<div className="border-b-[1px] border-dashed border-slate-300 my-4">
					<h2 className="text-sm text-slate-400 font-medium pb-3">ADRES</h2>
					<div className="font-light pb-3">ul. Miodowa 1, 00-080 Warszawa</div>
					<h2 className="text-sm text-slate-400 font-medium">EMAIL</h2>
					<div className="flex justify-between items-center">
						<div className="font-light">kontakt@akademialtca.pl</div>
						<a href="mailto:kontakt@akademialtca.pl">
							<EnvelopeCircleIcon />
						</a>
					</div>
					<h2 className="text-sm text-slate-400 font-medium">NUMER TELEFONU</h2>
					<div className="flex justify-between items-center">
						<div className="font-light">+48 575 692 694</div>
						<a href="tel:+48 575 692 694">
							<PhoneCircleIcon />
						</a>
					</div>
					<h2 className="text-sm text-slate-400 font-medium">
						STRONA INTERNETOWA
					</h2>
					<div className="flex justify-between items-center mb-5">
						<div className="font-light">akademialtca.pl</div>
						<a href="https://akademialtca.pl/">
							<LinkIcon />
						</a>
					</div>
				</div>
				<div className="flex justify-items-start items-center gap-10 align-middle">
					<h4>Znajdź nas</h4>
					<a href="https://www.facebook.com/LTCAwydarzenia" target="_blank">
						<FacebookIcon className="inline-block align-middle" />
					</a>
					<a
						href="https://www.instagram.com/explore/locations/676081622599790/akademia-ltca/"
						target="_blank"
					>
						<InstagramIcon />
					</a>
					<a
						href="https://www.linkedin.com/company/akademia-ltca/"
						target="_blank"
					>
						<LinkedinIcon />
					</a>
				</div>
				<div className="flex justify-between items-center mt-6">
					<div className="text-xs text-text2">v {version}</div>
					{/* {isStaging && (
						<>
						<button
							onClick={handleForceRefresh}
							disabled={isRefreshing}
							className="px-4 py-2 bg-orange-500 text-white rounded-lg text-sm font-medium hover:bg-orange-600 active:bg-orange-700 disabled:bg-gray-400 disabled:cursor-not-allowed transition-colors"
						>
							{isRefreshing ? '🔄 Odświeżanie...' : '🔄 Force Refresh Cache'}
						</button>
						<ErrorTest />
						</>
					)} */}
				</div>
			</div>
		</main>
	);
};
